import React from 'react';
import PropTypes from 'prop-types';

import {Title, Box} from 'views/components';

const CaregiverNameView = (props) => {
  const {
    caregiverData,
    setIsEditing,
  } = props;

  const caregiverName = caregiverData.caregiverName;

  return (
    <Box
      sx={{
        cursor: 'pointer',
      }}
      onClick={() => setIsEditing(true)}
    >
      <Title disableDivider sx={{my: '8px', fontWeight: 'bold'}}>
        {caregiverName}
      </Title>
    </Box>
  );
};

CaregiverNameView.propTypes = {
  caregiverData: PropTypes.object.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(CaregiverNameView);
